import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueApexCharts from "vue3-apexcharts";

loadFonts()
const app = createApp(App)
app.config.globalProperties.$encodeData = (data) =>{
      let codeString = `${data}`
      let encodeB64 = null     
      for (let i = 0; i < 5; i++) {      
        encodeB64 = btoa(codeString)
        codeString =  encodeB64
      }
      return  codeString;
    }
app.use(store)
app.use(router)
app.use(vuetify)
app.use(VueApexCharts)
app.mount('#app')
